import { Box, Typography } from '@mui/material'
import { FC, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import colors from '../../constants/colors'
import { AppDispatch } from '../../store'
import reportsSelectors from '../../store/reports/reportsSelectors'
import { getReportAnswers } from '../../store/reports/reportsSlice'
import answersParser from '../../utils/AnswersParser'
import AccordionTAG from '../AccordionTAG'
import CardTAG from '../CardTAG'
import ReportTriageLevel from './ReportTriageLevel'
import PageBodyLayout from '../PageBodyLayout'
import authSelectors from '../../store/auth/authSelectors'
import { APP_MODE } from '../../sharedTypes'
import CaseStatusMessageCard from './CaseStatusMessageCard'
import CaseUpdates from './CaseUpdates'

const InitialReport: FC = () => {
  const selectedCase = useSelector(reportsSelectors.selectedReport)
  const reportAnswers = useSelector(reportsSelectors.reportAnswers)
  const appMode = useSelector(authSelectors.userOrganizationType)

  /* eslint-disable */
  // // console.log('REPORT ANSWERS : ', reportAnswers)

  const dispatch = useDispatch<AppDispatch>()

  useEffect(() => {
    if (selectedCase) {
      dispatch(getReportAnswers({ reportId: selectedCase?.id }))
    }
  }, [selectedCase])

  const renderAnswers = () => {
    if (!reportAnswers?.length) {
      return <Typography variant='h1'>No Data</Typography>
    }
    if (reportAnswers) {
      return reportAnswers.map((item, index) => {
        if (item?.victim) {
          return <></>
        }
        return (
          <CardTAG title={item.question.text} key={`${item.uuid}${index}`}>
            {answersParser(item)}
          </CardTAG>
        )
      })
    }
  }

  return (
    <PageBodyLayout
      className={`t-initial-report-page ${appMode === APP_MODE.light ? 't-light-mode' : ''} `}
      filterPart={
        <>
          <Typography variant='h1' color={colors.TAG_BLUE} className={'t-page-body-left-title'}>
            Please review and triage this case to begin the investigation.
          </Typography>
          <div className='t-vbox t-gap-36'>
            <ReportTriageLevel />
            <CaseStatusMessageCard selectedReport={selectedCase} />
          </div>
        </>
      }
      dataPart={
        <div className='t-vbox t-gap-36 t-right-section-wrap'>
          <AccordionTAG title={`Case Updates`} boxError={false}>
            <Box className={'t-initial-report-questions'}>
              <CaseUpdates selectedReport={selectedCase} />
            </Box>
          </AccordionTAG>
          <AccordionTAG title={`Report for Case Number:${selectedCase?.case_number} `} boxError={false}>
            <Box className={'t-initial-report-questions'}>{renderAnswers()}</Box>
          </AccordionTAG>
        </div>
      }
    />
  )
}

export default InitialReport
